var exports = {
  "k": "x61f99309--7b5ec0--container",
  "K": "x61f99309--7b5ec0--icon",
};

module.exports = exports;
